import { type FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { TrialSuccess } from '../../Common/TrialSuccess'

export const InsightsSuccess: FC = () => {
  const navigate = useNavigate()

  return <TrialSuccess buttonLabel='Go to Insights now' onButtonClick={() => navigate('/insights')} />
}
